/**
 * apps/automations-portal/src/lib/firebase.ts
 *
 * Firebase Web SDK bootstrap for the "tidetable" project — the same
 * Firebase project used by apps/web and apps/attune-web, so a business
 * owner's Hattie Knows account and their Hattie Automations account are
 * the same sign-in.
 *
 * Config values default to the tidetable project's known values (these are
 * public client identifiers, not secrets — see apps/web/.env.production for
 * the same values used elsewhere in this monorepo) and can be overridden via
 * VITE_FIREBASE_* for local experimentation against a different project.
 */
import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const config: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyCSYcajC9t_DVmvbjYUnFtPopVj87qozcU',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'tidetable.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'tidetable',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '1:832386668769:web:7ffb6f15762b20043e3fa0',
};

const app = initializeApp(config);

export const auth = getAuth(app);
